var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7055 7.70598L21.99 6.07408C22.061 5.66648 21.7451 5.29368 21.3286 5.29368H19.2395C19.0325 5.29368 18.8748 5.10931 18.9083 4.90639L19.1755 3.28857C19.2189 3.02574 19.2065 2.7568 19.1391 2.49901C19.0833 2.28546 18.9172 2.11398 18.6987 2.04437L18.6403 2.02574C18.5083 1.98367 18.3642 1.99346 18.2397 2.05296C18.1028 2.11844 18.0025 2.23789 17.9654 2.37996L17.7736 3.1135C17.7126 3.34689 17.6237 3.57218 17.509 3.78505C17.3416 4.09607 17.0826 4.34499 16.8135 4.57508L16.2334 5.07099C16.0698 5.21082 15.9839 5.42022 16.0025 5.63376V9.00377C16.0025 9.55397 16.4485 10 16.9987 10H18.8731C20.2768 10 21.4747 9.02976 21.7055 7.70598Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6C13 5.44772 13.4477 5 14 5C14.5523 5 15 5.44772 15 6V9C15 9.55228 14.5523 10 14 10C13.4477 10 13 9.55228 13 9V6Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 20C1.25 19.5858 1.58579 19.25 2 19.25H22C22.4142 19.25 22.75 19.5858 22.75 20C22.75 20.4142 22.4142 20.75 22 20.75H2C1.58579 20.75 1.25 20.4142 1.25 20Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8731 11.5C19.6321 11.5 20.3616 11.308 21 10.963V17C21 17.5523 20.5523 18 20 18H4C3.44772 18 3 17.5523 3 17V6C3 4.89543 3.89543 4 5 4H12.4998C11.8927 4.45611 11.5 5.1822 11.5 6V9C11.5 10.3807 12.6193 11.5 14 11.5C14.5628 11.5 15.0822 11.314 15.5 11.0002C15.9174 11.314 16.4363 11.5 16.9987 11.5H18.8731Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopThumbsUp);
export default __webpack_public_path__ + "static/media/laptop-thumbs-up.0c423fab88054d839f14c373d1adcbac.svg";
export { ForwardRef as ReactComponent };